// src/pages/Map.js
import React from "react";

export default function MapPage() {
  return (
    <div
      style={{
        padding: 40,
        maxWidth: 800,
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      <h1>East Bay Hills Map</h1>

      <p style={{ color: "#555", marginTop: 8 }}>
        This interactive map is currently under construction.
      </p>

      <p style={{ marginTop: 16 }}>
        Future versions of this page will include:
      </p>

      <ul
        style={{
          textAlign: "left",
          display: "inline-block",
          marginTop: 12,
          color: "#444",
        }}
      >
        <li>East Bay Hills boundary visualization</li>
        <li>Wildfire risk layers</li>
        <li>Vegetation and fuel model data</li>
        <li>Interactive GIS overlays</li>
      </ul>

      <p style={{ marginTop: 24, fontSize: 14, color: "#777" }}>
        Map tools will return soon.
      </p>
    </div>
  );
}